import { render } from "./settings.html?vue&type=template&id=96483754&external"
import script from "./settings.js?vue&type=script&lang=js&external"
export * from "./settings.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__